import { inject, Injectable } from "@angular/core";
import { MemberAuth } from "src/app/backend/models/member/member-auth";
import { Tenant } from "src/app/backend/models/tenant/tenant";
import { ErrorCodes } from "src/app/modules/maintenance/error-codes";
import { MemberAuthProviderDefaultService } from "src/app/services/member-auth-provider/providers/member-auth-provider-default.service";
import { MemberAuthProviderPlatformService } from "src/app/services/member-auth-provider/providers/member-auth-provider-platform.service";
import { ProductService } from "src/app/services/product.service";
import { SoftwareProduct } from "src/app/support/product";

export type MemberAuthProviderResult = {
  error?: ErrorCodes;
  tenant?: Tenant;
  memberAuth?: MemberAuth;
  membersWithTenant?: Array<{
    member: MemberAuth;
    tenant: Tenant;
  }>;
  availableMembersAndTenants?: Array<{
    member: MemberAuth;
    tenant: Tenant;
  }>;
};

@Injectable()
export abstract class MemberAuthProviderService {
  abstract provide({
    accountNickName,
    domainSlug
  }: {
    domainSlug?: string;
    accountNickName?: string;
  }): Promise<MemberAuthProviderResult>;
}
